module.exports = __webpack_public_path__ + "img/yjsq.06799334.svg";